import { render, staticRenderFns } from "./slavery-statement.vue?vue&type=template&id=afc6b6b6&scoped=true&"
import script from "./slavery-statement.vue?vue&type=script&lang=js&"
export * from "./slavery-statement.vue?vue&type=script&lang=js&"
import style0 from "./slavery-statement.vue?vue&type=style&index=0&id=afc6b6b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc6b6b6",
  null
  
)

export default component.exports